import { motion } from "framer-motion";
import { useMemo } from "react";
import { TypingEffect } from "./TypingEffect";

interface SpeechBubbleProps {
    size?: "small" | "medium" | "large";
    transparent?: boolean;
    text: string;
    inAnimationDuration?: number;
    animationDelay?: number;
    onTypingComplete?: () => void;
    className?: string;
    useTypingEffect?: boolean;
}

export const SpeechBubble = ({ text, onTypingComplete, animationDelay = 0, inAnimationDuration = 0.3, className, size = "medium", transparent = true, useTypingEffect = true }: SpeechBubbleProps) => {
    const sizeClasses = {
        small: "max-w-[55%] text-sm p-2",
        medium: "max-w-[70%] p-4",
        large: "max-w-[90%] text-xl p-4",
    }

    // Generate a unique key based on the text content to force re-animation when text changes
    const textKey = useMemo(() => text, [text]);

    return (
        <motion.div
            key={useTypingEffect ? undefined : textKey}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: inAnimationDuration, delay: animationDelay, ease: "easeOut" }}
            onAnimationComplete={useTypingEffect ? undefined : onTypingComplete}
            className={`border-2 border-osGrey-4 rounded-xl relative w-fit text-osBlack font-semibold text-balance ${className} ${sizeClasses[size]} ${transparent ? "bg-transparent" : "bg-white"}`}>
            {useTypingEffect ? (
                <TypingEffect text={text} initialDelay={inAnimationDuration + animationDelay} onComplete={onTypingComplete} />
            ) : (
                text
            )}
        </motion.div>
    );
};